import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useResponsive } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Layout, PingMessages } from '@widgets';
import { BlockCard, CardLimit, Messages, Profile, RemindPin, RequestSupplementary, Statements, Transactions } from '@pages';

export const Private = () => {
  const { t } = useTranslation(['profile', 'card']);
  const { isMobile } = useResponsive();

  return (
    <>
      <PingMessages />
      <Routes>
        <Route
          path={RoutePaths.profile.path}
          element={
            <Layout header={t('title', { ns: 'profile' })} isProfile>
              <Profile />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.messages.path}
          element={
            <Layout>
              <Messages />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.lost.path}
          element={
            <Layout sidebar blank header={t('titles.lostOrStolenCSard', { ns: 'card' })}>
              <BlockCard />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.limit.path}
          element={
            <Layout sidebar blank header={t('titles.manageCardLimit', { ns: 'card' })}>
              <CardLimit />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.pin.path}
          element={
            <Layout sidebar blank header={t('titles.pinReminder', { ns: 'card' })}>
              <RemindPin />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.supplementaryCard.path}
          element={
            <Layout sidebar blank header={t('titles.requestSupplementaryCard', { ns: 'card' })}>
              <RequestSupplementary />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.statements.path}
          element={
            <Layout sidebar blank header={t('titles.statements', { ns: 'card' })}>
              <Statements />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.transactions.path}
          element={
            <Layout sidebar blank>
              <Transactions />
            </Layout>
          }
        />
        <Route
          path={RoutePaths.card.path}
          element={
            <Layout sidebar isMain>
              {!isMobile && <Transactions />}
            </Layout>
          }
        />
        <Route
          path='/'
          element={
            <Layout sidebar isMain>
              {!isMobile && <Transactions />}
            </Layout>
          }
        />
      </Routes>
    </>
  );
};
